import ModeleSaisieDetailController from './modele.saisie.detail.controller';

export default {
    template: require('./modele.saisie.detail.html'),
    controller: ModeleSaisieDetailController
};
